
/* eslint-disable */
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApiService } from 'services/apiservices';
let apiServices = new ApiService();

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar, Box, ClickAwayListener, List, ListItemButton, ListItemIcon, ListItemText, Paper, Popper, Stack, Typography, Grid, FormControl,
    OutlinedInput, Button, Alert
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';

// assets
import { IconLogout } from '@tabler/icons';
import constant from 'services/constant';
import { auth } from 'helper/Utility';
import { ADMIN_LOGIN } from 'helper/Constant'

import { QRCodeSVG } from 'qrcode.react';
import { TOTP, Secret } from 'otpauth';

const ProfileSection = () => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const [vendorData, setVendorData] = useState([]);
    const [baseUrl, setBaseUrl] = useState('');
    const [secret, setSecret] = useState(null);
    const [totp, setTotp] = useState(null);
    const [code, setCode] = useState('');
    const [msg, setMsg] = useState(null);
    const [stage, setStage] = useState('');

    const anchorRef = useRef(null);

    useEffect(() => {
        const savedSecretB32 = localStorage.getItem('admin2faSecret');
        if (savedSecretB32) {
            const existingSecret = Secret.fromBase32(savedSecretB32);
            const existingTotp = new TOTP({ issuer: 'Invoice', label: 'Admin', algorithm: 'SHA1', digits: 6, period: 30, secret: existingSecret });
            setSecret(existingSecret);
            setTotp(existingTotp);
            setStage('verify2fa');
        } else {
            const newSecret = new Secret({ size: 20 });
            const newTotp = new TOTP({ issuer: 'Invoice', label: 'Admin', algorithm: 'SHA1', digits: 6, period: 30, secret: newSecret });
            setSecret(newSecret);
            setTotp(newTotp);
            setStage('setup2fa');
        }
    }, []);

    // const enable2FA = () => {
    //     if (!totp || !secret) {
    //         setMsg('TOTP not initialized');
    //         return;
    //     }

    //     const delta = totp.validate({ token: code, window: 2 });
    //     if (delta !== null) {
    //         // ✅ Save secret in localStorage permanently
    //         localStorage.setItem('admin2faSecret', secret.base32);
    //         setMsg(null);
    //         setStage('verify2fa');
    //     } else {
    //         setMsg('Invalid 2FA code');
    //     }
    // };

    // Optional
    // const reset2FA = () => {
    //     localStorage.removeItem('admin2faSecret');
    //     setStage('setup2fa');
    //     setMsg(null);
    //     setCode('');
    //     const newSecret = new Secret({ size: 20 });
    //     const newTotp = new TOTP({
    //         issuer: 'Invoice',
    //         label: 'Admin',
    //         algorithm: 'SHA1',
    //         digits: 6,
    //         period: 30,
    //         secret: newSecret
    //     });
    //     setSecret(newSecret);
    //     setTotp(newTotp);
    // };


    // const handleLogout = async () => {
    //     localStorage.clear();
    //     window.location.href = ADMIN_LOGIN;
    // };

    const handleLogout = async () => {
        sessionStorage.clear();
        window.location.replace(ADMIN_LOGIN);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    return (
        <>
            <Avatar
                src={vendorData.image !== null ? baseUrl + vendorData.image : ''}
                sx={{
                    ...theme.typography.mediumAvatar,
                    margin: '8px 0 8px 8px !important',
                    cursor: 'pointer'
                }}
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="inherit"
            />

            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ p: 2 }}>
                                        <Stack>
                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                <Typography variant="h4">{auth('admin')?.firstName + " " + auth('admin')?.lastName}</Typography>
                                                <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                                    {vendorData.vendorname}
                                                </Typography>
                                            </Stack>
                                            <Typography variant="subtitle2" className='text-capitalize'>{auth("admin")?.role}</Typography>
                                        </Stack>
                                    </Box>

                                  
                                    <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                                        <Box sx={{ p: 2 }} className="pt-0">
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                                className="py-0"
                                            >
                                                <ListItemButton sx={{ borderRadius: `${customization.borderRadius}px` }} selected={selectedIndex === 4} onClick={handleLogout}>
                                                    <ListItemIcon>
                                                        <IconLogout stroke={1.5} size="1.3rem" />
                                                    </ListItemIcon>
                                                    <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                                                </ListItemButton>
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>
        </>
    );
};

export default ProfileSection;
